<template>
  <!-- 发布帖子 -->

  <el-dialog :title="$t('发布文章')" width="879px" top="8vh" :visible.sync="isVisible" @close="closeModal">

    <el-form ref="ruleForm" :model="form" label-width="auto" :rules="rules">
      <el-form-item :label="$t('文章标题')" prop="ttar_title">
        <el-input v-model="form.ttar_title" :placeholder="$t('请输入文章标题')" name="ttar_title"></el-input>
      </el-form-item>

      <el-form-item :label="$t('文章分类')">
        <el-select v-model="form.tt_id" :placeholder="$t('请选择文章分类')" :key="conmmontKey" @change="handlerChange">
          <el-option :label="item.tt_title" :value="item.tt_id" v-for="item in classData" :key="item.tt_id">
            {{ item.tt_title }}
          </el-option>

        </el-select>
      </el-form-item>
      <el-form-item :label="$t('文章来源')">

        <el-select v-model="form.ttar_source" :placeholder="$t('请选择来源')">
          <el-option :label="item.label" :value="item.value" v-for="(item, index) in articleScore"
                     :key="index"></el-option>
        </el-select>
      </el-form-item>

      <Editor v-model="form.ttar_content" :height="500" :isUseOss="true" />

      <div class="languige-text mt-8 harmonyos-text">
        {{ $t('发送语言版本') }}
        <el-tooltip :content="$t('可切换语言，在您的个人中心检查译文是否正确')" placement="top-start" effect="light">
          <span class="iconfont">&#xe677;</span>
        </el-tooltip>
        <!-- <el-checkbox v-for="(langitem, langindex) in datalist.other_lang" v-model="form.other_lang[langindex]"
          :key="langitem.tws_id" class="ml-28">{{ langitem.tws_name }}
        </el-checkbox> -->
        <el-checkbox-group v-model="form.other_lang" style="display: inline-block;" class="ml-23">
          <el-checkbox :label="langitem.tws_id" v-for="(langitem, langindex) in datalist.other_lang" :key="langindex">
            {{ $t('article.' + langitem.tws_name) }}
          </el-checkbox>

        </el-checkbox-group>
      </div>
      <!--  v-if="userinfo.user_expert == 10" -->

<!--      <div class="languige-text harmonyos-text" v-if="userinfo.user_expert == 10">-->
<!--        {{ $t('以实名身份发布') }}-->
<!--        <el-tooltip :content="$t('以专家身份实名发布后文章页面会同步展示实名信息')" placement="bottom-start" effect="light">-->
<!--          <span class="iconfont">&#xe677;</span>-->
<!--        </el-tooltip>-->
<!--        <el-checkbox-group v-model="form.is_expert" style="display: inline-block;" class="ml-23">-->
<!--          <el-checkbox :key="10" :label="10">{{ $t('是') }}</el-checkbox>-->
<!--        </el-checkbox-group>-->

<!--      </div>-->


    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="closeModal" class="btn1">{{ $t('取消') }}</el-button>
      <el-button type="primary" class="btn2" @click="submitPost">{{ $t('确定') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex';
import Editor from "../components/Editor/index.vue";
import { getMyInfo } from "@api/home";

export default {
  components: {
    Editor
  },
  computed: {
    ...mapState('home', ['datalist'])

  },
  props: {

    classData: {
      type: Array, // 指定参数类型
      required: true // 是否为必需参数
    },
    articleScore: {
      type: Array, // 指定参数类型
      // required: false // 是否为必需参数
      default: function() {
        return [
          { label: '原创', value: 10 },
          { label: '转载', value: 20 }
        ];
      }
    },
    tt_id: {
      // layout/index里默认传入的空字符串 thumbsId
      type: Number | String,
      default: 0
    }
  },
  data() {
    return {
      conmmontKey: 1,

      isVisible: false,
      postContent: '',
      userinfo: [],
      form: {
        ttar_title: "",
        tt_id: "",
        ttar_content: '',
        ttar_source: 10,
        other_lang: [],
        is_expert: [10],
        user_expert: 20
      },

      rules: {
        ttar_title: [
          { required: true, message: this.$t('请填写正确的文章标题'), trigger: 'blur' }
        ],
        ttar_content: [
          { required: true, message: this.$t('请填写正确的文章内容'), trigger: 'blur' }
        ]
      }
    };
  },
  mounted() {
    this.getCurrUserData();
  },
  watch: {
    datalist: function(newData) {
      this.form.other_lang = newData.other_lang.map((lang) => lang.tws_id)
      
    }
  },
  methods: {

    handlerChange(item) {
      this.conmmontKey += 1;
      this.form.tt_id = item;
    },
    // async getCurrUserData() {
    //   let res = await getMyInfo();

    //   if (res.status == 200) {
    //     this.userinfo = res.data;
    //   }
    // },

    async getCurrUserData() {
      // 获取用户信息，本地是否有缓存，有就直接使用，没有就请求接口
      if(localStorage.getItem('userinfo')) {
        this.userinfo = JSON.parse(localStorage.getItem('userinfo'));
        return false;
      }
      let res = await getMyInfo();
      if (res.status == 200) {
        this.userinfo = res.data;
        // 存储到localStorage
        localStorage.setItem('userinfo', JSON.stringify(res));
      }
    },

    openModal() {

      this.form.tt_id = this.tt_id ? this.tt_id : "";
      this.conmmontKey = 1;
      this.isVisible = true;
      this.form.other_lang = this.datalist.other_lang.map((lang) => lang.tws_id);
    },
    closeModal() {
      this.isVisible = false;
      this.$refs['ruleForm'].clearValidate();
      this.$refs['ruleForm'].resetFields();
      setTimeout(() => {
        this.conmmontKey = 2;

        this.form = {
          ttar_title: "",
          ttar_content: '',
          ttar_source: 10,
          tt_id: "",
          other_lang: this.datalist.other_lang.map((lang) => lang.tws_id),
          is_expert: [10]
        }
      }, 200);
    },
    submitPost() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (!this.form.ttar_content.trim()) {
            this.$message.error(this.$t('请填写正确的文章内容'));
            return false;
          }

          if (this.userinfo.user_expert == 20) this.form.is_expert[0] = 20;
          this.form.is_expert = this.form.is_expert.length > 0 ? this.form.is_expert[0] : '';
          this.$emit('post-submitted', { ...this.form });

          setTimeout(() => {
            this.closeModal();
          }, 200);
          var _this = this;
          setTimeout(() => {
            _this.form = {
              ttar_title: "",
              ttar_content: 10,
              tp_source: 10,
              other_lang: [0],
              is_expert: [10]
            }
          }, 200);
        } else {
          const firstErrorField = this.$refs.ruleForm.fields.find(field => field.validateState === 'error');
          const errorElement = document.getElementsByName(firstErrorField.prop)[0];
          if (errorElement) {
            errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }

      })
      // this.form.tt_id = this.tt_id;
      // if (this.form.ttar_title == '') {
      //     this.$message.error(this.$t('请填写正确的文章标题'));
      //     return false;
      // }
      // if (this.form.tt_id == 0) {
      //     return false;
      // }


    }
  }
};
</script>

<style scoped lang="scss">
.languige-text {
  font-size: 14px;
  font-weight: 400;
  color: rgb(25, 25, 25);
  line-height: 24px;
  margin-top: 4px;

  ::v-deep() {
    .el-checkbox__label {
      font-family: "harmonyos";
      color: #191919;
    }
  }
}

::v-deep() {
  .el-form-item__label:before {
    color: transparent !important;
  }

  .el-select {
    width: 100%;
  }

  .el-input__inner {
    height: 52px;
    padding-left: 23px;
    border: none;
    font-size: 14px;
    background-color: transparent;
    color: #949494;

    &::placeholder {
      color: #949494;
    }
  }

  .el-form-item__label {
    padding: 0 21px 0 0;
    position: relative;

    &::after {
      content: "";
      display: block;
      height: 14px;
      width: 1px;
      background-color: #CEC7C6;
      position: absolute;
      right: 0;
      top: 20px;
    }
  }

  .el-form-item__label-wrap .el-form-item__label {
    line-height: 52px;
    color: #423735;
    font-size: 14px;
  }

  .el-form-item {
    height: 54px;
    background-color: #F8F8F8;
    padding: 1px 22px;
    border-radius: 4px;
    margin-bottom: 20px;
    border-radius: 5px;
    border: 1px solid #F2F1F1;
  }

  .el-form-item.red-box {
    background-color: #FDF3F2;
  }

  .el-dialog__headerbtn {
    display: none;

  }

  .el-dialog__header {
    padding: 28px 32px 0px;
  }

  .el-dialog {
    max-height: 82vh;
    border-radius: 12px;
    // transform: translateY(-50%);
    // top: 50%;
  }

  .mce-flow-layout {
    background-color: #FDF3F2;
  }

  .mce-panel {
    border: 0 solid #e2e1e1;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: none;
  }

  .mce-btn {
    background-color: transparent;
  }

  .el-dialog__body {
    margin-top: 20px;
    width: calc(100% - 24px);
    padding: 0px 12px 0 36px;
    max-height: calc(82vh - 180px);
    overflow: hidden;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 6px;
      height: 4px;
      background: transparent;
      border-radius: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background: #CF4325;
      border-radius: 8px;
    }
  }

  .el-dialog__footer {
    padding: 26px 36px 26px;
  }

  .dialog-footer {

    .btn1,
    .btn2 {
      min-width: 76px;
      height: 36px;
      border-radius: 30px;
      padding: 0 16px;
      font-size: 14px;
    }

    .btn1 {
      background-color: #ffffff;
      border: 1px solid #ededed;

      &:hover {
        border: 1px solid #d9462f;
      }
    }

    .btn2 {
      // background-color: #D64F31;
      background: linear-gradient(to right, #eb6f54, #d9462f);
      border: none;

      &:hover {
        background: linear-gradient(to right, #d9462f, #d9462f);
      }
    }
  }

  .el-button+.el-button {
    margin-left: 24px;
  }
}
</style>